import styled from 'styled-components'
import palette from '../../../theme/palette'
import { ResourceHubElementWithColorSchemeProps } from '../../../models/organisms/ResourceHub'
import { Icon } from '../../atoms/Icon/Icon.styles'

export const SortSelectWrapper = styled.div`
  position: relative;
  margin-left: auto;
`

export const SortSelectTrigger = styled.button<{ $isOpen: boolean } & ResourceHubElementWithColorSchemeProps>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.rem(8)};
  padding: ${({ theme }) => `${theme.rem(10)} ${theme.rem(12)}`};
  border-radius: ${({ theme }) => theme.rem(4)};
  border: 1px solid ${({ theme, $isOpen, colorScheme }) => ($isOpen ? theme.colorScheme[colorScheme].tabs.selected.bgPressed : theme.colorScheme[colorScheme].icon.base.tertiary)};
  background: ${({ $isOpen, colorScheme, theme }) =>
    $isOpen ? theme.colorScheme[colorScheme].surface.text.base.negative : 'transparent'};
  font-size: ${({ theme }) => theme.rem(16)};
  line-height: ${({ theme }) => theme.rem(24)};
  color: ${({ $isOpen, colorScheme, theme }) =>
    $isOpen ? theme.colorScheme[colorScheme].surface.text.base.primary : theme.colorScheme[colorScheme].icon.base.tertiary};
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].tabs.selected.bgPressed};
    background-color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].tabs.selected.bgPressed};
    color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.text.base.primary};
    ${Icon} {
      color: ${({ theme, colorScheme }) => theme.colorScheme[colorScheme].surface.text.base.primary};
    }
  }

  svg {
    width: ${({ theme }) => theme.rem(18)};
    height: ${({ theme }) => theme.rem(18)};
    transition: transform 0.2s ease;
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
`

export const SortSelectDropdown = styled.div`
  position: absolute;
  top: calc(100% + ${({ theme }) => theme.rem(4)});
  right: 0;
  z-index: 10;
  min-width: ${({ theme }) => theme.rem(180)};
  border-radius: ${({ theme }) => theme.rem(8)};
  background: ${palette.grayscale[50]};
  border: 1px solid ${palette.grayscale[100]};
  box-shadow: 0 2px 12px 0 rgba(0, 34, 33, 0.10);
  padding: ${({ theme }) => `${theme.rem(8)} 0`};
`

export const SortSelectOption = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => `${theme.rem(10)} ${theme.rem(16)}`};
  border: none;
  background: ${({ $active }) => ($active ? palette.grayscale[100] : 'transparent')};
  font-size: ${({ theme }) => theme.rem(14)};
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  color: ${palette.green[300]};
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${palette.grayscale[100]};
  }
`
